export default __webpack_public_path__ + "static/media/mot_2.0d36a7cc.svg";